<div class="page-container container">
  <app-utility-toolbar />
  <h1 class="header mb-3">User Settings</h1>

  <div class="info-card w-50">
    <div class="card-header"> Appearance </div>

    <div class="card-info">
      <span class="radio-container mb-3">
        <mat-label>Theme</mat-label>
        <mat-radio-group
          [disabled]="true"
          [(ngModel)]="currentTheme"
          (change)="changeTheme($event)"
        >
          <mat-radio-button class="me-3" [value]="'RightBridge'">
            RightBRIDGE <sup>(Default)</sup>
          </mat-radio-button>
          <mat-radio-button class="me-3" [value]="'StateFarm'">
            State Farm
          </mat-radio-button>
        </mat-radio-group>
      </span>

      <span class="radio-container">
        <mat-label>Mode</mat-label>
        <mat-radio-group
          [(ngModel)]="currentScheme"
          (change)="changeScheme($event)"
        >
          <mat-radio-button class="me-3" [value]="'light'">
            Light
          </mat-radio-button>
          <mat-radio-button checked class="me-3" [value]="'dark'">
            Dark
          </mat-radio-button>
        </mat-radio-group>
      </span>
    </div>
  </div>
</div>
